import { render, staticRenderFns } from "./compGuide.vue?vue&type=template&id=17ddfae9&"
import script from "./compGuide.vue?vue&type=script&lang=js&"
export * from "./compGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports